// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-m_Hz1UzD","ad_1":"ad_1-2wDwUA62","ad_2":"ad_2-31eJwCqh"};